export const isUuid = (str) => {
  // Regular expression to check if string is a valid UUID
  const regexExp =
    /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
  return regexExp.test(str); // true
};

export const isIban =
  /^(?:(?:CR|DE|ME|RS|VA)[0-9]{20}|(?:CZ|ES|SE|SK|TN)[0-9]{22}|(?:DK|FI|FO|GL|SD)[0-9]{16}|(?:AT|BA|EE|LT|XK)[0-9]{18}|(?:AE|IL|TL)[0-9]{21}|(?:LY|PT|ST)[0-9]{23}|(?:IT|SM)[0-9]{2}[A-Z][0-9]{10}[A-Za-z0-9]{12}|(?:HU|PL)[0-9]{26}|(?:AL|CY)[0-9]{10}[A-Za-z0-9]{16}|(?:CH|LI)[0-9]{7}[A-Za-z0-9]{12}|(?:FR|MC)[0-9]{12}[A-Za-z0-9]{11}[0-9]{2}|(?:GB|IE)[0-9]{2}[A-Z]{4}[0-9]{14}|(?:KZ|LU)[0-9]{5}[A-Za-z0-9]{13}|(?:GI|IQ)[0-9]{2}[A-Z]{4}[A-Za-z0-9]{15}|(?:PK|RO)[0-9]{2}[A-Z]{4}[A-Za-z0-9]{16}|(?:PS|QA)[0-9]{2}[A-Z]{4}[A-Za-z0-9]{21}|AD[0-9]{10}[A-Za-z0-9]{12}|AZ[0-9]{2}[A-Z]{4}[A-Za-z0-9]{20}|BE[0-9]{14}|BG[0-9]{2}[A-Z]{4}[0-9]{6}[A-Za-z0-9]{8}|BH[0-9]{2}[A-Z]{4}[A-Za-z0-9]{14}|BR[0-9]{25}[A-Z][A-Za-z0-9]|BY[0-9]{2}[A-Za-z0-9]{4}[0-9]{4}[A-Za-z0-9]{16}|DO[0-9]{2}[A-Za-z0-9]{4}[0-9]{20}|EG[0-9]{27}|GE[0-9]{2}[A-Z][0-9]{16}|GT[0-9]{2}[A-Za-z0-9]{24}|GR[0-9]{9}[A-Za-z0-9]{16}|HR[0-9]{19}|IS[0-9]{24}|JO[0-9]{2}[A-Z]{4}[0-9]{4}[A-Za-z0-9]{18}|KW[0-9]{2}[A-Z]{4}[A-Za-z0-9]{22}|LC[0-9]{2}[A-Z]{4}[A-Za-z0-9]{24}|LB[0-9]{6}[A-Za-z0-9]{20}|LV[0-9]{2}[A-Z]{4}[0-9]{13}|MD[0-9]{2}[A-Za-z0-9]{20}|MK[0-9]{5}[A-Za-z0-9]{10}[0-9]{2}|MR[0-9]{25}|MT[0-9]{2}[A-Z]{4}[0-9]{5}[A-Za-z0-9]{18}|MU[0-9]{2}[A-Z]{4}[0-9]{19}[A-Z]{3}|NL[0-9]{2}[A-Z]{4}[0-9]{10}|NO[0-9]{13}|SA[0-9]{4}[A-Za-z0-9]{18}|SC[0-9]{2}[A-Z]{4}[0-9]{20}[A-Z]{3}|SI[0-9]{17}|SV[0-9]{2}[A-Z]{4}[0-9]{20}|TR[0-9]{8}[A-Za-z0-9]{16}|UA[0-9]{8}[A-Za-z0-9]{19}|VG[0-9]{2}[A-Z]{4}[0-9]{16}|GE[0-9]{2}[A-Z]{2}[0-9]{16})$/;

export const isSwiftCode = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/gi;

export const getNameOfBankFinamaze = (key) => {
  const banks = [
    { name: "New York Bank", currency: "USD" },
    { name: "New York Bank", currency: "USD" },
    { name: "Abu Dhabi Bank", currency: "AED" },
  ];

  return banks[key];
};

export const feedback = (formik, field) => {
  const { errors, touched } = formik;

  if (errors[field] && touched[field]) {
    return errors[field];
  }
  return null;
};
